'use client';

export default function GlobalError({ reset }: { error: Error; reset: () => void }) {
  return (
    <html>
      <body style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
        backgroundColor: '#1a1a1a' // Changed to dark background
      }}>
        <div style={{
          textAlign: 'center',
          padding: '40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          alignItems: 'center'
        }}>
          <img
            src="/logos/shib_logo.png"
            alt="Shib Logo"
            style={{
              width: '200px',
              height: '50px',
              marginBottom: '20px'
            }}
          />
          <h2 style={{ color: '#ffffff' }}>Something went wrong!</h2>
          <p style={{ color: '#ffffff' }}>
            Please check your internet connection and try again.
          </p>
          <button
            style={{
              padding: '10px 24px',
              fontSize: '16px',
              color: '#ffffff',
              backgroundColor: '#ff6b24', // Changed to orange
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '20px'
            }}
            onClick={() => {
              reset();
              window.location.reload();
            }}
          >
            Reload page
          </button>
        </div>
      </body>
    </html>
  );
};